module.exports = __webpack_public_path__ + "9c047ad63696a26aef1ede8b267f86b0.svg";